import SanitizedGrid from "../../components/SanitizedGrid";
import { Grid, Typography } from "@material-ui/core";
import {
  FunctionField,
  ShowProps,
  TextField,
  useRecordContext,
} from "react-admin";
import { notificationTargetType } from "./const";
import NotificationTargetField from "./components/NotificationTargetField";
import NotificationReceiverReferenceField from "./components/NotificationReceiverReferenceField";
import CustomLabeled from "../../components/layout/CustomLabeled";

const Summary = (props: ShowProps) => {
  const notificationTargetTypeFormatter = (id: string, source: any): string => {
    const item = source.find((type: any) => type.id === id);
    return item ? item.name : "-";
  };

  const record = useRecordContext();
  const notificationPayload = record?.payload
    ? JSON.parse(record.payload)
    : null;

  return (
    <>
      <SanitizedGrid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom>
            Notification Target
          </Typography>
        </Grid>

        <Grid item xs={3}>
          <CustomLabeled name="Target Type">
            <FunctionField
              render={(record: any) =>
                notificationTargetTypeFormatter(
                  record.targetType,
                  notificationTargetType
                )
              }
            />
          </CustomLabeled>
        </Grid>
        <Grid item xs={9}></Grid>

        <NotificationTargetField />

        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom>
            Send Notification To
          </Typography>
        </Grid>

        <Grid item>
          {notificationPayload?.IsSendToAllParents ? (
            <CustomLabeled name="Parent Name">
              <Typography variant="body2">Send to All Parents</Typography>
            </CustomLabeled>
          ) : (
            <NotificationReceiverReferenceField
              sourceField="parents"
              sourceIds={notificationPayload?.ParentIds}
              labelField="Parent Name"
              labelSourceField="firstName"
              orderBy="firstName"
              orderType="ASC"
            >
              <FunctionField
                render={(record: any) => (
                  <Typography variant="body2">
                    {record["salutation"]} {record["firstName"]}{" "}
                    {record["lastName"]}
                  </Typography>
                )}
              />
            </NotificationReceiverReferenceField>
          )}
        </Grid>
        <Grid item xs={12} style={{ padding: 0 }}></Grid>

        <Grid item>
          {notificationPayload?.IsSendToAllDrivers ? (
            <CustomLabeled name="Driver Name">
              <Typography variant="body2">Send to All Drivers</Typography>
            </CustomLabeled>
          ) : (
            <NotificationReceiverReferenceField
              sourceField="drivers"
              sourceIds={notificationPayload?.DriverIds}
              labelField="Driver Name"
              labelSourceField="fullName"
              orderBy="fullName"
              orderType="ASC"
            />
          )}
        </Grid>
        <Grid item xs={12} style={{ padding: 0 }}></Grid>

        <Grid item>
          {notificationPayload?.IsSendToAllBusAssistants ? (
            <CustomLabeled name="Bus Assistant Name">
              <Typography variant="body2">Send to All Bus Assistant</Typography>
            </CustomLabeled>
          ) : (
            <NotificationReceiverReferenceField
              sourceField="busAssistants"
              sourceIds={notificationPayload?.BusAssistantIds}
              labelField="Bus Assistant"
              labelSourceField="fullName"
              orderBy="fullName"
              orderType="ASC"
            />
          )}
        </Grid>
        <Grid item xs={12} style={{ padding: 0 }}></Grid>

        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom>
            Notification Detail
          </Typography>
        </Grid>

        <Grid item xs={4}>
          <CustomLabeled name="Title">
            <TextField source="title" emptyText="-" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={8}></Grid>

        <Grid item xs={12}>
          <CustomLabeled name="Body">
            <TextField source="body" emptyText="-" />
          </CustomLabeled>
        </Grid>
      </SanitizedGrid>
    </>
  );
};

export default Summary;
